import React, { useState, useEffect } from "react";
import TreeContainer from "./TreeContainer";
import { ownStore } from "../../AppOwnState/ownState";
import {
  ExecuteLayoutEventMethods,
  GetControlPropertyFromStoreOrRefData,
  getProcessedDynamic,
} from "../../General/commonFunctions";

const MenuTree = (props) => {
  const [tree, setTree] = useState([]);

  useEffect(() => {
    if (!props?.dset) return;
    const unsubscribe = ownStore?.subscribe((storeInfo) => {
      const menuDs = ownStore.getState(props?.dset);
      setTree(menuDs);
    }, props.dset);

    return () => unsubscribe && unsubscribe();
  }, [props?.dset]);

  const updateTree = (treeKey, updated) => {
    if (treeKey === "tree") {
      ownStore.dispatch({
        type: "STORE_DATASET",
        payload: {
          dataSetName: props?.dset,
          data: updated,
        },
      });
    }
  };

  const handleSelectItem = async (node) => {
    if (props.whenfocusedrowchanged) {
      await ExecuteLayoutEventMethods(props.whenfocusedrowchanged, node);
    }
  };

  const handleDoubleClick = async (node) => {
    if (props.whenrowdblclick) {
      await ExecuteLayoutEventMethods(props.whenrowdblclick, node);
    }
  };

  const onFocusOut = async (node) => {
    if (props.whenrowfocusout) {
      await ExecuteLayoutEventMethods(props.whenrowfocusout, node);
    }}

  return (
    <TreeContainer
      title={props?.title || ""}
      handleSelectItem={handleSelectItem}
      tree={tree}
      onChange={updateTree}
      onDoubleClick={handleDoubleClick}
      onFocusOut={onFocusOut}
      template={props.content}
    />
  );
};

export default MenuTree;
